import React from 'react';

import Button from '@atlaskit/button';

import { CreateFolderModalButton } from '../CreateFolderModalButton';
import {
  ContainerStyled,
  TitleStyled,
  WrapperStyled,
} from './TestCaseRepositorySidebarHeader.styled';

const openDocumentationPage = () => {
  window.open('https://soldevelo.atlassian.net/l/cp/DR711qyK', '_blank');
};

export function TestCaseRepositorySidebarHeader(): JSX.Element {
  return (
    <ContainerStyled>
      <WrapperStyled>
        <TitleStyled>Test Cases</TitleStyled>
        <CreateFolderModalButton />
      </WrapperStyled>
      <div>
        Browse or search for Folders and Test Cases.{' '}
        <Button
          appearance='link'
          spacing='none'
          onClick={openDocumentationPage}
        >
          Learn more in Documentation
        </Button>
      </div>
    </ContainerStyled>
  );
}
